var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "text-h5 font-weight-bold",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" Informações da Turma Selecionada ")]), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Escola",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.turma.escola,
      callback: function ($$v) {
        _vm.$set(_vm.turma, "escola", $$v);
      },
      expression: "turma.escola"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Município",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.turma.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.turma, "municipio", $$v);
      },
      expression: "turma.municipio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "GRE",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.turma.gre,
      callback: function ($$v) {
        _vm.$set(_vm.turma, "gre", $$v);
      },
      expression: "turma.gre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.turma.nomeTurma,
      callback: function ($$v) {
        _vm.$set(_vm.turma, "nomeTurma", $$v);
      },
      expression: "turma.nomeTurma"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ano/Série",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.turma.anoSerie,
      callback: function ($$v) {
        _vm.$set(_vm.turma, "anoSerie", $$v);
      },
      expression: "turma.anoSerie"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantidade de Estudantes Matriculados",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.turma.estudantesMatriculados,
      callback: function ($$v) {
        _vm.$set(_vm.turma, "estudantesMatriculados", $$v);
      },
      expression: "turma.estudantesMatriculados"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }